<template>
  <dp-draft-edit :subNavTitle="title" :capsule="capsule" :saveMessage="saveMessage"></dp-draft-edit>
</template>

<script>
  import CreateTemplate from '../../requests/creationPages/DPCreateTemplate.vue'
  export default {
    name: 'Capsule-Draft-Edit',
    data: () => {
      return {
        title: 'Edit Direct Payment',
        capsule: 'draft-edit',
        saveMessage: 'Draft saved'
      }
    },
    components: {
      'dp-draft-edit': CreateTemplate
    }
  }
</script>



// WEBPACK FOOTER //
// TDraftEdit.vue?62a90cd9